import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "learn-tooltip__content" }
const _hoisted_2 = {
  key: 0,
  class: "learn-tooltip__content__title"
}
const _hoisted_3 = {
  key: 1,
  class: "learn-tooltip__content__sub-title"
}
const _hoisted_4 = { class: "learn-tooltip__footer" }
const _hoisted_5 = { class: "learn-tooltip__counter-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "learn-tooltip__step"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "learn-tooltip__btns" }
const _hoisted_9 = {
  key: 1,
  class: "learn-tooltip__divider"
}
const _hoisted_10 = {
  key: 3,
  class: "learn-tooltip__divider"
}
const _hoisted_11 = {
  key: 0,
  class: "learn-tooltip__overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createBlock(_component_VDropdown, {
    id: _ctx.id,
    autoHide: false,
    triggers: [],
    shown: _ctx.shown,
    disabled: !_ctx.shown,
    placement: _ctx.placement,
    skidding: _ctx.skidding,
    distance: _ctx.distance,
    class: _normalizeClass(["learn-tooltip", [
      { 'is-circle': _ctx.isCircle },
      { 'is-active': _ctx.step === _ctx.selectedStep && _ctx.shown },
      { 'is-body-bg': _ctx.isBodyBg },
      `indentation-${_ctx.indentationAroundElement}`
    ]]),
    theme: "info-dropdown",
    popperClass: `learn-tooltip__popper ${_ctx.popperClass}`,
    onApplyShow: _ctx.onShowDropdown,
    onApplyHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onHideDropdown')))
  }, {
    popper: _withCtx(({ hide }) => [
      _renderSlot(_ctx.$slots, "tooltip-content", { hide: hide }, () => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.tooltipText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.tooltipText), 1))
            : _createCommentVNode("", true),
          (_ctx.tooltipSubText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.tooltipSubText), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "before-counter"),
          _renderSlot(_ctx.$slots, "counter", {}, () => [
            (_ctx.maxStep > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedStepNumber) + " of " + _toDisplayString(_ctx.maxStep), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "   "))
          ]),
          _renderSlot(_ctx.$slots, "after-counter")
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.selectedStepNumber > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "learn-tooltip__next",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrev && _ctx.onPrev(...args)))
              }, [
                _createVNode(_component_BaseSubHeading, {
                  size: "medium",
                  weight: "500",
                  color: "--monochrome-00",
                  darkColor: "--monochrome-07"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Prev ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStepNumber < _ctx.maxStep && _ctx.selectedStepNumber > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.selectedStepNumber < _ctx.maxStep)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "learn-tooltip__next",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
              }, [
                _createVNode(_component_BaseSubHeading, {
                  size: "medium",
                  weight: "500",
                  color: "--monochrome-00",
                  darkColor: "--monochrome-07"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Next ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStepNumber === _ctx.maxStep && _ctx.maxStep > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.selectedStepNumber === _ctx.maxStep)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: "learn-tooltip__next",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
              }, [
                _createVNode(_component_BaseSubHeading, {
                  size: "medium",
                  weight: "500",
                  color: "--monochrome-00",
                  darkColor: "--monochrome-07"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Close ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (_ctx.showOverlay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true)
        ]))
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tooltip-label")
    ]),
    _: 3
  }, 8, ["id", "shown", "disabled", "placement", "skidding", "distance", "class", "popperClass", "onApplyShow"]))
}